import { render } from "./LITTPay.vue?vue&type=template&id=8dcb3c1a"
import script from "./LITTPay.vue?vue&type=script&lang=js"
export * from "./LITTPay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__